import * as React from 'react';

import { Card } from 'antd';


export default Card;
